module.exports = __webpack_public_path__ + "img/img45.68190f57.png";